import { getWindow } from './window';
// eslint-disable-next-line dot-notation
getWindow()['localVariants'] = {
  // This variant is introduced as a mechanism to implement and control the signup blocking feature.
  // It avoids removing existing code, making rollbacks easier if needed.
  // During cleanup, this variant flag pattern makes it easier to identify
  // and remove all associated code without missing implementation details.
  'corps.blockSelfServiceSignup': {
    page: 'Self Service Signup Flow',
    url: '/corporate/signup/step/{stepNumber}',
    description:
      'Block access to the self-service signup flow and redirect users',
    selected: true,
    createDate: '06/23/2025',
    ticket: 'CEC-5309',
    stakeholder: 'Rodrigo Artavia',
  },
  'corps.enableAutofillCorp': {
    page: 'Corps',
    url: '/corporate/enterprise/corps/create',
    description: 'Enable autofill corp form button for testing',
    selected: false,
    createDate: '09/19/2025',
    ticket: 'CEC-5444',
    stakeholder: 'Rodrigo Artavia',
  },
  'site.cookbook.enableAuditMode': {
    page: 'Global Variants',
    url: '*',
    description: 'Enable Audit Mode for Cookbook',
    selected: false,
    createDate: '04/29/2025',
    ticket: 'PLEX-7157',
    stakeholder: 'Sahir Memon',
  },
  'plex.enableGrubApiCore': {
    page: 'Global Variants',
    url: '',
    description: 'Enable Grub API Core functionality',
    selected: true,
    createDate: '08/15/2025',
    ticket: 'PLEX-7413',
    stakeholder: 'Sahir Memon',
  },
  'plex.enableCookieBasedAuth': {
    page: 'Global Variants',
    url: '',
    description: 'Enable Cookie Based Authentication',
    selected: true,
    createDate: '10/01/2025',
    ticket: 'PLEX-7546',
    stakeholder: 'Sahir Memon',
  },
  'plex.showSsoOnNativeOption': {
    page: 'Corps',
    url: '/corporate/enterprise/corps/{corpId}',
    description: 'Show the SSO on native option in the Corp Edit/Add page',
    selected: false,
    createDate: '12/10/2025',
    ticket: 'PLEX-7834',
    stakeholder: 'Alexandru Iaru',
  },
  'corps.enableReportingFeature': {
    page: 'Corps',
    url: '/corporate/enterprise/{corpId}/reports',
    description: 'Enable Corporate Order Reporting feature',
    selected: true,
    createDate: '02/24/2026',
    ticket: 'CEC-6337',
    stakeholder: 'Rodrigo Artavia',
  },
  'corps.reportingInternalOnlyPhase': {
    page: 'Corps',
    url: '/corporate/enterprise/{corpId}/reports',
    description:
      'Limit reporting to internal admins only (disable for GA rollout to all admins)',
    selected: true,
    createDate: '03/24/2026',
    ticket: 'CEC-6410',
    stakeholder: 'Rodrigo Artavia',
  },
  'plex.balancePostLaunchImprovements': {
    page: 'Self Service App',
    url: '/corporate/management/{corpId}/home',
    description: 'Balance Post-Launch Improvements',
    selected: false,
    createDate: '04/24/2026',
    ticket: 'PLEX-8428',
    stakeholder: 'Albert Hong',
  },
  'plex.enableBusinessInsights': {
    page: 'Enterprise corp home page',
    url: '/corporate/enterprise/{corpId}/home',
    description: 'Enable Business Admin Insights on Enterprise corp Home page',
    selected: false,
    createDate: '06/05/2026',
    ticket: 'PLEX-8477',
    stakeholder: 'Albert Hong',
  },
};
